import { DatePicker, TimePicker } from 'antd';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import locale from 'antd/lib/date-picker/locale/de_DE';
import TextArea from 'antd/lib/input/TextArea';
import * as moment from 'moment';
import { Moment } from 'moment';
import 'moment/locale/de-at';
import * as React from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { RouteComponentProps, StaticContext } from 'react-router';
import Toggle from 'react-toggle';
import { url, history } from 'src';
import ImagePicker from 'src/components/utils/ImagePicker/ImagePicker';
import SuggestUser from 'src/pages/Event/EventDetail/AddParticipant/SuggestUser';
import { alertError } from 'src/store/alert/actions';
import { createEvent } from 'src/store/events/actions';
import {
  Bus,
  CreateEventData,
  Difficulties,
  DifficultiesText,
  EventTypes,
  EventTypesNames,
  Station
} from 'src/store/events/types';
import { User } from 'src/store/user/types';
import { Daterange, DateShortForms, formatDate, WeekDays } from 'src/utils/dateHelper';
import { arrayUnique } from 'src/utils/sharedHelpers';
import '../../../utils/styles/toggle.scss';
import './CreateEvent.scss';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import cloneDeep from 'lodash.clonedeep';
import { IconPaths } from 'src/icons';

const { RangePicker } = DatePicker;

interface StationInput {
  stationName: string;
  stationTime: Date | null;
}

export interface FormValues {
  title: string;
  shortDescription: string;
  description: string;
  quota: number | '';
  bikesAllowed: boolean;
  dateranges: Daterange[];
  eventType: number;
  // date: { startDate: Date | null; endDate: Date | null };
  weekDays: number[];
  startTime: Date | null;
  familyFriendly: boolean;
  age: number | '';
  price: number | '';
  difficulty: number;
  buses: Bus[];
  stations: Station[];
  picture?: File;
  guides: User[];
  meetingpoint: string;
  duration: string;
  currentImageUrl?: string;
}

interface Props {
  createEvent: typeof createEvent;
  alertError: typeof alertError;
  loading: boolean;
  loadingImage: boolean;
  getUsers: any;
  guides: User[];
  initialValues: FormValues;
  editMode: boolean;
  eventgroupId?: number;
  sectionTitle?: string;
}

interface MyState {
  errors: any;
  values: FormValues;
  touched: any;
  isValid: boolean;
  submitted: boolean;
  image?: File;
  disabled: any;
  tempValues: {
    guests: any;
    station: StationInput;
    guide?: User;
    stationEdit: number;
  };
}

const InputStructure = ({ render, className }: any) => (
  <div className={'row' + (className ? ' ' + className : '')}>{render}</div>
);

const ErrorMessage = ({ state, name }: any) => (
  <React.Fragment>
    {(state.touched[name] || state.submitted) && state.errors[name] && (
      <div className="error">{state.errors[name]}</div>
    )}
  </React.Fragment>
);

type AllProps = Props & RouteComponentProps<any, StaticContext, any>;

class CreateEventForm extends React.Component<AllProps, MyState> {
  constructor(props: AllProps) {
    super(props);

    this.state = {
      errors: {},
      image: undefined,
      values: this.props.initialValues,
      touched: {},
      isValid: false,
      submitted: false,
      disabled: {
        quota: true,
        minAge: true
      },
      tempValues: {
        guests: '',
        station: {
          stationName: '',
          stationTime: null
        },
        stationEdit: -1,
        guide: undefined
      }
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.generateInput = this.generateInput.bind(this);
    this.setError = this.setError.bind(this);
    this.validateField = this.validateField.bind(this);
    this.resetError = this.resetError.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.generateTextArea = this.generateTextArea.bind(this);
  }

  componentDidMount() {
    this.validateForm();
    this.props.getUsers();
  }

  onDrop = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      this.setState(prevState => ({
        ...prevState,
        image: file
      }));
    }
  };

  renderCheckboxes = (name: string, value: any, label?: any) => {
    const values = { ...this.state.values };
    const ret = [];
    if (label) {
      ret.push(label);
    }
    for (const item in value) {
      if (!isNaN(Number(item))) {
        const itemNum = Number(item);
        ret.push(
          <div
            key={itemNum}
            className={
              'blockCheckbox' +
              (this.state.errors[name] && this.state.touched[name] ? ' inputError' : '')
            }
          >
            <input
              name={name}
              id={name + itemNum}
              type="checkbox"
              onBlur={this.handleBlur.bind(this, name)}
              value={itemNum}
              checked={values.weekDays.includes(itemNum)}
              onChange={e => {
                if (e.target.checked) {
                  console.log(e.target.value);
                  this.setState(
                    prevState => ({
                      ...prevState,
                      values: {
                        ...prevState.values,
                        weekDays: arrayUnique([...prevState.values.weekDays, itemNum])
                      }
                    }),
                    () => {
                      console.log(this.state.values.weekDays);
                      this.validateField(name);
                    }
                  );
                } else {
                  const idx = values.weekDays.indexOf(itemNum);
                  const weekDays = [...this.state.values.weekDays];
                  weekDays.splice(idx, 1);
                  this.setState(
                    prevState => ({
                      ...prevState,
                      values: {
                        ...prevState.values,
                        weekDays
                      }
                    }),
                    () => {
                      this.validateField(name);
                    }
                  );
                }
              }}
            />
            <label htmlFor={name + itemNum}>{DateShortForms[WeekDays[itemNum]]}</label>
          </div>
        );
      }
    }
    ret.push(
      <React.Fragment key={'weekDayError'}>
        <ErrorMessage state={this.state} name={name} />
      </React.Fragment>
    );

    return ret;
  };

  renderRadio = (name: string, value: any, fieldText: any, fieldTextNames: any, label?: any) => {
    const values = { ...this.state.values };
    const ret = [];
    if (label) {
      ret.push(label);
    }
    for (const item in value) {
      if (!isNaN(Number(item))) {
        const itemNum = Number(item);
        ret.push(
          <div
            key={name + itemNum}
            className={
              'blockCheckbox' +
              (this.state.errors[name] && this.state.touched[name] ? ' inputError' : '')
            }
          >
            <input
              name={name}
              id={name + itemNum}
              type="radio"
              onBlur={this.handleBlur.bind(this, name)}
              value={itemNum}
              checked={values[name] === itemNum}
              onChange={() => {
                this.setState(
                  prevState => ({
                    ...prevState,
                    values: {
                      ...prevState.values,
                      [name]: itemNum
                    }
                  }),
                  () => {
                    console.log(this.state.values);
                    this.validateField(name);
                  }
                );
              }}
            />
            <label htmlFor={name + itemNum}>{fieldText[fieldTextNames[itemNum]]}</label>
          </div>
        );
      }
    }
    ret.push(
      <React.Fragment key={'difficultyError'}>
        <ErrorMessage state={this.state} name={name} />
      </React.Fragment>
    );

    return ret;
  };

  handleBlur(name: string) {
    const touched = { ...this.state.touched };
    touched[name] = true;
    this.setState({ touched });
  }

  handleChange(e: any, name: string, value?: any) {
    if (Array.isArray(this.state.values[name])) {
      this.setState(
        prevState => {
          return {
            ...prevState,
            values: {
              ...prevState.values,
              [name]: [...prevState.values[name], value]
            }
          };
        },
        () => {
          this.validateField(name);
        }
      );
    } else {
      let stateValue: any;
      if (value !== undefined) {
        stateValue = value;
      } else {
        stateValue = e.target.value;
      }

      this.setState(
        prevState => {
          return {
            ...prevState,
            values: {
              ...prevState.values,
              [name]: stateValue
            }
          };
        },
        () => {
          this.validateField(name);
        }
      );
    }
  }

  handleChangeTimeRange = (range: Daterange, index: number, name: string) => {
    const dateranges = [...this.state.values.dateranges];

    const length = this.state.values.dateranges.length;

    if (range.start === undefined && range.end === undefined) {
      if (length > 1) {
        dateranges.splice(index, 1);
      }
    } else {
      dateranges[index] = range;

      if (index + 1 >= length) {
        dateranges.push({ start: undefined, end: undefined });
      }
    }

    this.setState(
      prevState => {
        return {
          ...prevState,
          values: {
            ...prevState.values,
            dateranges
          }
        };
      },
      () => {
        console.log(this.state.values[name]);
        this.validateField(name);
      }
    );
  };

  setError(name: string, value: string | null) {
    this.setState(prevState => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        [name]: value
      }
    }));
  }

  generateTextArea(name: string, label?: any) {
    return (
      <InputStructure
        render={
          <React.Fragment>
            {label ? label : null}
            <TextArea
              id={name}
              onChange={e => this.handleChange(e, name)}
              onBlur={() => this.handleBlur(name)}
              value={this.state.values[name]}
            />
          </React.Fragment>
        }
      />
    );
  }

  generateInput(name: string, type: string, label?: any, placeholder = '', min = '', max = '') {
    return (
      <React.Fragment>
        {label != null && label}
        <input
          id={name}
          min={min}
          max={max}
          type={type}
          className={this.errorClassName(name)}
          placeholder={placeholder}
          onBlur={this.handleBlur.bind(this, name)}
          value={this.state.values[name]}
          onChange={e => {
            this.handleChange(e, name);
          }}
        />
        <ErrorMessage state={this.state} name={name} />
      </React.Fragment>
    );
    // return <InputStructure render={renderFunc} />;
  }

  resetError(name: string) {
    if (this.state.errors[name] != null) {
      this.setError(name, null);
    }
  }

  validateField(name: string): boolean | null {
    const value = this.state.values[name];
    let valid = true;
    switch (name) {
      case 'title': {
        if (!value || value.length <= 0) {
          this.setError(name, 'Bitte geben Sie einen Titel ein');
          valid = false;
        } else {
          this.resetError(name);
        }
        break;
      }
      case 'weekDays': {
        if (!value || value.length <= 0) {
          this.setError(name, 'Bitte wählen Sie mind. einen Wochentag aus');
          valid = false;
        } else {
          this.resetError(name);
        }
        break;
      }
      case 'date': {
        if (!value || !value.startDate || !value.endDate) {
          this.setError(name, 'Bitte wählen Sie einen Zeitraum aus');
          valid = false;
        } else {
          this.resetError(name);
        }
        break;
      }
      case 'dateranges': {
        if (!value || !value[0] || !value[0].start || !value[0].end) {
          this.setError(name, 'Bitte wählen Sie mind. einen Zeitraum aus');
          valid = false;
        } else {
          this.resetError(name);
        }
      }
      case 'startTime': {
        if (!value) {
          this.setError(name, 'Bitte wählen Sie eine Startzeit aus');
          valid = false;
        } else {
          this.resetError(name);
        }
        break;
      }
      case 'quota': {
        if (value !== '' && value <= 0) {
          this.setError(name, 'Kontingent muss größer als 0 sein');
          valid = false;
        } else {
          this.resetError(name);
        }
      }
      case 'price': {
        if (value !== '' && value < 0) {
          this.setError(name, 'Preis kann nicht negativ sein');
          valid = false;
        } else {
          this.resetError(name);
        }
      }
      default:
        return true;
    }
    return valid;
  }

  validateForm(): boolean {
    let result = true;
    for (const prop in this.state.values) {
      if (this.state.values.hasOwnProperty(prop)) {
        if (!this.validateField(prop)) {
          result = false;
        }
      }
    }
    this.setState({ isValid: result });
    return result;
  }

  // rangeContainsWeekDays(weekDays: number[], startDate: Date, endDate: Date) {}

  // errorClassName = (property: string) => {
  //   return this.state.errors[property] && this.state.touched[property] ? 'inputError' : '';
  // };
  errorClassName = (property: string) => {
    return this.state.errors[property] && (this.state.touched[property] || this.state.submitted)
      ? 'inputError'
      : '';
  };

  render() {
    const { loadingImage } = this.props;
    return (
      <div className="container">
        <div className="col-lg-5 centered">
          <InputStructure
            render={this.generateInput('title', 'text', <label htmlFor="title">Titel</label>)}
          />

          <InputStructure
            render={
              <React.Fragment>
                <div className="col-lg-6 noPad" style={{ textAlign: 'left' }}>
                  <label htmlFor="startTime">Startzeit</label>
                  <TimePicker
                    className={this.errorClassName('startTime')}
                    defaultOpenValue={moment(
                      this.state.values.startTime ? this.state.values.startTime : 0
                    )}
                    placeholder={
                      this.state.values.startTime
                        ? formatDate(this.state.values.startTime, 'HH:mm')
                        : '00:00'
                    }
                    format="HH:mm"
                    minuteStep={1}
                    onChange={(time: Moment) => {
                      this.handleChange(null, 'startTime', time ? time.toDate() : time);
                    }}
                    onOpenChange={e => {
                      if (!e) {
                        this.handleBlur('startTime');
                        this.validateField('startTime');
                      }
                    }}
                  />
                </div>
                <ErrorMessage state={this.state} name="startTime" />
                <div className="col-lg-6 noPad">
                  {this.generateInput(
                    'duration',
                    'string',
                    <label htmlFor="duration">Dauer</label>
                  )}
                </div>
              </React.Fragment>
            }
          />

          <InputStructure
            render={
              <React.Fragment>
                <label className="" htmlFor="familyFriendly">
                  Familienprogrammpunkt
                </label>

                <Toggle
                  defaultChecked={this.state.values.familyFriendly}
                  onChange={() => {
                    this.handleChange(null, 'familyFriendly', !this.state.values.familyFriendly);
                  }}
                />
                {this.state.values.familyFriendly &&
                  this.generateInput(
                    'age',
                    'number',
                    <label style={{ marginTop: '4px' }} className="sm" htmlFor="age">
                      Alter ab (Jahren)
                    </label>,
                    '',
                    '1',
                    '99'
                  )}
              </React.Fragment>
            }
          />

          <InputStructure
            render={
              <React.Fragment>
                <label key="guideLabel">Guides</label>
                <SuggestUser
                  errorClassName={this.errorClassName('guides')}
                  placeholder="Guide"
                  value={this.state.tempValues.guide}
                  type="guide"
                  onBlur={this.handleBlur.bind(this, 'guides')}
                  onSelected={(user: User) => {
                    this.setState(prevState => ({
                      ...prevState,
                      tempValues: {
                        ...prevState.tempValues,
                        guide: user
                      }
                    }));
                  }}
                />
                <button
                  type="button"
                  onClick={() => {
                    const guide = this.state.tempValues.guide;
                    if (guide !== undefined) {
                      this.resetError('guides');
                      this.setState(prevState => ({
                        ...prevState,
                        values: {
                          ...prevState.values,
                          guides: prevState.values.guides.some(user => user.id === guide.id)
                            ? prevState.values.guides
                            : [...prevState.values.guides, guide]
                        }
                      }));
                    } else {
                      this.setError('guides', 'Bitte wählen sie einen Guide aus');
                      this.handleBlur('guides');
                    }
                  }}
                >
                  Guide hinzufügen
                </button>
                <table className="styledTable" style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th />
                      <th>Name</th>
                      <th>E-Mail</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.values.guides &&
                      this.state.values.guides.map((guide, index) => (
                        <tr key={index}>
                          <td />
                          <td>{guide.name}</td>
                          <td>{guide.email}</td>
                          <td>
                            <button
                              onClick={() => {
                                const userId = this.state.values.guides.findIndex(
                                  (user: User) => user.id === guide.id
                                );
                                const guides = [...this.state.values.guides];
                                guides.splice(userId, 1);
                                this.setState(prevState => {
                                  return {
                                    ...prevState,
                                    values: {
                                      ...prevState.values,
                                      guides
                                    }
                                  };
                                });
                              }}
                            >
                              X
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <ErrorMessage name="guides" state={this.state} />
              </React.Fragment>
            }
          />
          <React.Fragment>
            <InputStructure
              render={this.renderCheckboxes(
                'weekDays',
                WeekDays,
                <label key="weekdayLabel">Wochentage</label>
              )}
            />
            <InputStructure
              render={
                <React.Fragment>
                  <label htmlFor="date">Zeitraum</label>
                  {this.state.values.dateranges.map((range: Daterange, index: number) => (
                    <RangePicker
                      key={index}
                      className={this.errorClassName('dateranges')}
                      onOpenChange={e => {
                        if (!e) {
                          this.handleBlur('dateranges');
                          this.validateField('dateranges');
                        }
                      }}
                      defaultValue={
                        range.start && range.end
                          ? [moment(range.start), moment(range.end)]
                          : undefined
                      }
                      defaultPickerValue={
                        range.start && range.end
                          ? [moment(range.start), moment(range.end)]
                          : undefined
                      }
                      format="DD.MM.YYYY"
                      id="dateranges"
                      locale={locale}
                      onChange={(dates: RangePickerValue) => {
                        this.handleChangeTimeRange(
                          { start: dates[0], end: dates[1] },
                          index,
                          'dateranges'
                        );
                      }}
                    />
                  ))}

                  <ErrorMessage state={this.state} name="dateranges" />
                </React.Fragment>
              }
            />
          </React.Fragment>

          <InputStructure
            render={
              <React.Fragment>
                {this.generateInput(
                  'price',
                  'number',
                  <label htmlFor="price">Preis (€)</label>,
                  '',
                  '1'
                )}
              </React.Fragment>
            }
          />

          <InputStructure
            render={this.generateInput(
              'meetingpoint',
              'string',
              <label htmlFor="meetingpoint">Treffpunkt</label>
            )}
          />

          <InputStructure
            render={
              <div className="difficulty">
                {this.renderRadio(
                  'difficulty',
                  Difficulties,
                  DifficultiesText,
                  Difficulties,
                  <label key="difficultyLabel">Schwierigkeit</label>
                )}
              </div>
            }
          />

          {this.generateTextArea(
            'shortDescription',
            <label htmlFor="shortDescription">Kurzbeschreibung</label>
          )}
          {this.generateTextArea('description', <label htmlFor="description">Beschreibung</label>)}

          <InputStructure
            render={
              <div className="eventTypes">
                {this.renderRadio('eventType', EventTypes, EventTypesNames, EventTypes)}
              </div>
            }
          />
          {/* Render quota input if event type is default */}
          {this.state.values.eventType === 0 && (
            <InputStructure
              render={
                <React.Fragment>
                  <label htmlFor="quota">Kontingent</label>
                  {/* <span className={this.state.disabled.quota ? '' : 'hidden'}>&infin;</span> */}
                  <input
                    type="number"
                    value={this.state.values.quota}
                    pattern="[0-9]*"
                    min="1"
                    className={this.errorClassName('quota')}
                    onBlur={this.handleBlur.bind(this, 'quota')}
                    onChange={e => {
                      this.handleChange(e, 'quota', e.target.value);
                    }}
                  />
                  <ErrorMessage state={this.state} name="quota" />
                </React.Fragment>
              }
            />
          )}

          {/* Render Bus input if event type is Bus */}
          {this.state.values.eventType !== 0 && (
            <InputStructure
              render={
                <React.Fragment>
                  <label className="sm" htmlFor="seats">
                    Anzahl der Sitzplätze
                  </label>
                  {/* <span className={this.state.disabled.quota ? '' : 'hidden'}>&infin;</span> */}
                  <input
                    type="number"
                    value={this.state.tempValues.guests}
                    pattern="[0-9]*"
                    min="1"
                    className={this.errorClassName('guests')}
                    onBlur={this.handleBlur.bind(this, 'guests')}
                    onChange={e => {
                      const value = e.target.value;
                      this.setState(prevState => ({
                        ...prevState,
                        tempValues: {
                          ...prevState.tempValues,
                          guests: value
                        }
                      }));
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      const quota = this.state.tempValues.guests;
                      if (!isNaN(Number(quota)) && quota > 0) {
                        this.resetError('guests');
                        let hidden = true;
                        if (this.state.values.buses.length === 0) {
                          hidden = false;
                        }
                        const newBus: Bus = { id: -1, hidden, quota };
                        this.setState(prevState => ({
                          ...prevState,
                          values: {
                            ...prevState.values,
                            buses: [...this.state.values.buses, newBus]
                          }
                        }));
                      } else {
                        this.setError('guests', 'Anzahl der Gäste muss eine Zahl größer 0 sein');
                        this.handleBlur('guests');
                      }
                    }}
                  >
                    +
                  </button>
                  <ErrorMessage state={this.state} name="guests" />

                  <table className="buses">
                    <thead>
                      <tr>
                        <th>Versteckt</th>
                        <th>Bus</th>
                        <th>Anz.</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.values.buses.map((bus, i) => (
                        <tr key={i}>
                          <td>
                            <div className="styledCheckbox">
                              <input
                                type="checkbox"
                                id={'bus' + i}
                                onChange={() => {
                                  const buses = [...this.state.values.buses];
                                  buses[i].hidden = !buses[i].hidden;
                                  this.setState(prevState => ({
                                    ...prevState,
                                    values: {
                                      ...prevState.values,
                                      buses
                                    }
                                  }));
                                }}
                                checked={this.state.values.buses[i].hidden}
                              />
                              <label htmlFor={'bus' + i} />
                            </div>
                          </td>
                          <td>Bus{i + 1}</td>
                          <td>{bus.quota}</td>
                          <td
                            onClick={() => {
                              const buses = [...this.state.values.buses];
                              buses.splice(i, 1);
                              this.setState(prevState => ({
                                ...prevState,
                                values: {
                                  ...prevState.values,
                                  buses
                                }
                              }));
                            }}
                          >
                            x
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="addStations">
                    <div className="stationName">
                      <label className="sm" htmlFor="stationName">
                        Station hinzufügen
                      </label>
                      <input
                        id="stationName"
                        type="text"
                        value={this.state.tempValues.station.stationName}
                        className={this.errorClassName('stationName')}
                        onBlur={this.handleBlur.bind(this, 'stationName')}
                        onChange={e => {
                          const value = e.target.value;
                          this.setState(prevState => ({
                            ...prevState,
                            tempValues: {
                              ...prevState.tempValues,
                              station: {
                                ...prevState.tempValues.station,
                                stationName: value
                              }
                            }
                          }));
                        }}
                      />
                      <ErrorMessage state={this.state} name="stationName" />
                    </div>

                    <div className="stationTime">
                      <label htmlFor="stationTime" className="sm">
                        Startzeit
                      </label>
                      <TimePicker
                        className={this.errorClassName('stationTime')}
                        defaultOpenValue={moment(0)}
                        format="HH:mm"
                        minuteStep={1}
                        placeholder="00:00"
                        onChange={(time: Moment) => {
                          console.log(time);
                          this.setState(prevState => ({
                            ...prevState,
                            tempValues: {
                              ...prevState.tempValues,
                              station: {
                                ...prevState.tempValues.station,
                                stationTime: time.toDate()
                              }
                            }
                          }));
                        }}
                        onOpenChange={e => {
                          if (!e) {
                            this.handleBlur('stationTime');
                            this.validateField('stationTime');
                          }
                        }}
                      />
                      <ErrorMessage state={this.state} name="stationTime" />
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        const station = this.state.tempValues.station;
                        if (station.stationName.length > 0 && station.stationTime != null) {
                          this.resetError('stationName');
                          this.resetError('stationTime');
                          const newStation: Station = {
                            place: station.stationName,
                            time: formatDate(station.stationTime, 'HH:mm')
                          };

                          const stations = [...this.state.values.stations, newStation];

                          stations.sort((a, b) => {
                            const start = moment(a.time, 'HH:mm');
                            const end = moment(b.time, 'HH:mm');
                            if (start.isBefore(end)) {
                              return -1;
                            } else if (start.isAfter(end)) {
                              return 1;
                            } else {
                              return 0;
                            }
                          });

                          this.setState(prevState => ({
                            ...prevState,
                            tempValues: {
                              ...prevState.tempValues,
                              station: {
                                ...prevState.tempValues.station,
                                stationName: '',
                                stationTime: null
                              }
                            },
                            values: {
                              ...prevState.values,
                              stations
                            }
                          }));
                        } else {
                          if (station.stationName.length <= 0) {
                            this.setError('stationName', 'Bitte geben Sie einen Namen ein');
                            this.handleBlur('stationName');
                          }
                          if (station.stationTime == null) {
                            this.setError('stationTime', 'Bitte wählen Sie ein Uhrzeit aus');
                            this.handleBlur('stationTime');
                          }
                        }
                      }}
                    >
                      +
                    </button>
                  </div>
                  <div className="stationTable">
                    <table className="stations">
                      <thead>
                        <tr>
                          <th>Nr.</th>
                          <th>Station</th>
                          <th>Uhrzeit</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.values.stations.map((station, i) => (
                          <tr key={i} className="deletable">
                            <td>{i + 1}</td>
                            <td>
                              <input
                                id="stationName"
                                type="text"
                                title={station.place}
                                style={{ fontSize: '1rem' }}
                                value={this.state.values.stations[i].place}
                                className={this.errorClassName('stationName' + i)}
                                onBlur={this.handleBlur.bind(this, 'stationName' + i)}
                                onChange={e => {
                                  const value = e.target.value;
                                  const stations = cloneDeep(this.state.values.stations);
                                  stations[i].place = value;
                                  this.setState(prevState => ({
                                    ...prevState,
                                    values: {
                                      ...prevState.values,
                                      stations
                                    }
                                  }));
                                }}
                              />
                              <ErrorMessage state={this.state} name={`stationName${i}`} />
                            </td>
                            <td>
                              <TimePicker
                                className={this.errorClassName('stationTime' + i)}
                                defaultOpenValue={moment(
                                  this.state.values.stations[i].time,
                                  'HH:mm'
                                )}
                                format="HH:mm"
                                minuteStep={1}
                                placeholder={moment(
                                  this.state.values.stations[i].time,
                                  'HH:mm'
                                ).format('HH:mm')}
                                onChange={(time: Moment) => {
                                  const stations = cloneDeep(this.state.values.stations);
                                  stations[i].time = time.format('HH:mm');

                                  this.setState(prevState => ({
                                    ...prevState,
                                    values: {
                                      ...prevState.values,
                                      stations
                                    }
                                  }));
                                }}
                                onOpenChange={e => {
                                  if (!e) {
                                    this.handleBlur('stationTime' + i);
                                    this.validateField('stationTime' + i);
                                  }
                                }}
                              />
                              <ErrorMessage state={this.state} name={`stationTime${i}`} />
                            </td>
                            <td>
                              {/* <img
                                src={IconPaths['edit-icon']}
                                title={station.id + ''}
                                onClick={() => {
                                  this.setState(prevState => ({
                                    ...prevState,
                                    tempValues: {
                                      ...prevState.tempValues,
                                      stationEdit: i
                                    }
                                  }));
                                }}
                              /> */}
                              <img
                                src={IconPaths['bin-icon']}
                                onClick={() => {
                                  const stations = [...this.state.values.stations];
                                  stations.splice(i, 1);
                                  this.setState(prevState => ({
                                    ...prevState,
                                    values: {
                                      ...prevState.values,
                                      stations
                                    }
                                  }));
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </React.Fragment>
              }
            />
          )}

          <InputStructure
            render={
              <React.Fragment>
                <div>
                  <label>Bilder</label>
                  {this.state.values.currentImageUrl && (
                    <img
                      src={url + this.state.values.currentImageUrl}
                      style={{ maxHeight: '200px', maxWidth: '100%', objectFit: 'cover' }}
                    />
                  )}
                  {this.state.image && (
                    <img
                      src={URL.createObjectURL(this.state.image)}
                      style={{ maxHeight: '200px', maxWidth: '100%', objectFit: 'cover' }}
                    />
                  )}
                  <ImagePicker onChange={this.onDrop} />
                  <div>
                    <LoadingSpinner pending={loadingImage} />
                  </div>
                </div>
              </React.Fragment>
            }
          />

          <InputStructure
            render={
              <button
                type="submit"
                onClick={this.handleSubmit}
                disabled={this.state.submitted && this.props.loading}
              >
                {this.props.editMode ? 'Speichern' : 'Erstellen'}
              </button>
            }
          />
        </div>
      </div>
    );
  }
  handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    this.setState({ submitted: true });
    if (this.validateForm()) {
      const values = this.state.values;
      if (
        values.dateranges.length > 0 &&
        values.dateranges[0].start !== undefined &&
        values.dateranges[0].end !== undefined &&
        values.startTime
      ) {
        let dateranges = [...values.dateranges];
        dateranges = dateranges.filter(
          value => value.start !== undefined && value.end !== undefined
        );
        dateranges.forEach(dr => {
          dr.weekdays = values.weekDays;
          if (values.startTime !== null) {
            const startDate = moment(dr.start);
            startDate.set({
              h: values.startTime.getHours(),
              m: values.startTime.getMinutes(),
              s: 0
            });
            dr.start = startDate;
          }
        });
        values.buses.forEach((bus: Bus) => {
          bus.stations = values.stations;
        });
        const event: CreateEventData = {
          bikesAllowed: values.eventType === EventTypes.bikeBus,
          description: values.description,
          dateranges,
          hidden: false,
          quota: values.quota === '' ? null : values.quota,
          sectionTitle:
            this.props.match.params.sectionTitle !== 'undefined'
              ? this.props.match.params.sectionTitle
              : this.props.sectionTitle,
          shortDescription: values.shortDescription,
          title: values.title,
          // weekdays: values.weekDays,
          difficulty: values.difficulty,
          familyfriendly: values.familyFriendly ? (values.age !== '' ? values.age : -1) : -2,
          price: values.price !== '' ? values.price : undefined,
          buses: values.buses,
          guides: values.guides.map(guide => guide.id),
          meetingpoint: values.meetingpoint === '' ? undefined : values.meetingpoint,
          duration: values.duration === '' ? undefined : values.duration
        };
        if (this.props.editMode && this.props.eventgroupId) {
          event.eventgroupId = this.props.eventgroupId;
        }
        console.log(event);
        this.props.createEvent(event, this.state.image, () => {
          history.push('/');
        });
      } else {
        this.props.alertError(new Error('Formular fehlerhaft'));
      }
    } else {
      console.error('CREATE EVENT FORM INVALID');
    }
  }
}

export default CreateEventForm;



// WEBPACK FOOTER //
// ./src/components/Event/EventManagement/CreateEventForm.tsx